module.exports = __webpack_public_path__ + "static/media/buttonsounds09.9d1ae55e.wav";